import { render, staticRenderFns } from "./BdRobot.vue?vue&type=template&id=7a8b41ee&"
import script from "./BdRobot.vue?vue&type=script&lang=js&"
export * from "./BdRobot.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports